import pixNProgress from '../shared/pixNProgress';
import Console from '@/shared/console';

const commonInterceptors = {
  setCommonInterceptors(axiosInstance) {
    axiosInstance.interceptors.request.use(
      (config) => {
        pixNProgress.start();
        return config;
      },
      (error) => {
        pixNProgress.start();
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        pixNProgress.done();
        return response;
      },
      (error) => {
        pixNProgress.done();
        return Promise.reject(error);
      }
    );
  },

  setErrorInterceptors(axiosInstance, store, errorMessage) {
    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error) {
          const theRequestHasBeenCanceled = error.canceled;
          if (!theRequestHasBeenCanceled) {
            const errorStatus = error.response?.status;
            const isAuthenticated = store.getters['authModule/isAuthenticated'];
            if (errorStatus === 401 && isAuthenticated) {
              // Se lanza llamada a obtener un nuevo token y este se utiliza para reintentar la llamada
              return store
                .dispatch('authModule/renew')
                .then((res) => {
                  const newPixAuthToken = JSON.parse(res.access_token).idToken;
                  error.config.baseURL = undefined;
                  error.config.headers.Authorization = `Bearer ${newPixAuthToken}`; // Even if we use an axios instance with the correct auth header, if we trigger the same call as before we need to manually update the auth token
                  return axiosInstance.request(error.config);
                })
                .catch((err) => {
                  // Si da error el reintento de la llamada, se fuerza logout para que el usuario haga login de nuevo y obtenga nuevo token siguiendo el flujo estandar
                  Console.error('Renew token error', err);
                  store.dispatch('authModule/unloadPixAuthToken');
                  store.dispatch('authModule/unloadOktaAuthToken');
                  window.location.reload();
                });
            } else if (errorStatus === 504) {
              store.dispatch('toastModule/warning', 'The operation has timed out');
            } else if (errorStatus !== 409) {
              store.dispatch('toastModule/error', errorMessage);
            }
          }
        } else {
          store.dispatch('toastModule/error', 'Unknown error');
        }
        return Promise.reject(error);
      }
    );
  },

  setAuthHeader(axiosInstance, token) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  },

  deleteAuthHeader(axiosInstance) {
    delete axiosInstance.defaults.headers.common.Authorization;
  },
};

export default commonInterceptors;
